export default "__VITE_ASSET__f36710a9__"